import {Bars3Icon} from '@heroicons/react/24/outline'
import Sidebar from "./Sidebar";
import CollectionDialog from "../../tags/CollectionDialog";
import {useAtom} from "jotai/index";
import {showMobileSidebarAtom} from "./Storage";
import MobileSidebar from "./MobileSidebar";

interface Props {
    children: any
}

export default function ApplicationShell(props: Props) {

    const [, setShowMobileSidebar] = useAtom(showMobileSidebarAtom);

    return (
        <>
            <MobileSidebar/>
            <Sidebar/>

            <div
                className="sticky top-0 z-40 flex items-center gap-x-6 bg-white px-4 py-4 shadow-sm sm:px-6 lg:hidden">
                <button type="button" className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
                        onClick={() => setShowMobileSidebar(true)}>
                    <span className="sr-only">Open sidebar</span>
                    <Bars3Icon className="h-6 w-6" aria-hidden="true"/>
                </button>
                <div className="flex-1 text-sm font-semibold leading-6 text-gray-900">Freedom on the Move Database</div>
            </div>

            <main className="lg:pl-72 h-full mt-2">
                {props.children}

                <CollectionDialog/>
            </main>
        </>
    )
}
